angular
    .module('app')
    .directive('d3Axis', ['d3Service', '$window', '$timeout', function (d3Service, $window, $timeout) {
        return {
            restrict: 'EA',
            scope: {
                data: '=',
                level: '=',
                src: '=',
                fields: '=',
                options: '='
            },
            link: function (scope, el, attrs) {
                d3Service.d3().then(function (d3) {

                    scope.render = {};

                    var renderTimeout;
                    var margin = parseInt(attrs.margin) || 20,
                        barHeight = parseInt(attrs.barHeight) || 20,
                        barPadding = parseInt(attrs.barPadding) || 5

                    var svg = d3.select(el[0])
                        .append('svg')
                        .style('width', '100%');

                    $window.onresize = function () {
                        scope.$apply();
                    };

                    scope.$watch(function () {
                        return angular.element($window)[0].innerWidth;
                    }, function () {
                        scope.render[scope.src](scope.data);
                    });

                    scope.$watch('data', function (newData) {
                        scope.render[scope.src](newData);
                    }, true);

                    // scope.onClick = function (d) {
                    //     console.info('d3 bar click', d);
                    // };

                    scope.render[scope.src] = function (data) {
                        var tmp = angular.element(el[0]);
                        tmp.find('svg:not(:last)').remove();
                        d3.selectAll('.chart-tooltip').remove();

                        if (!data)
                            return;

                        if (renderTimeout)
                            clearTimeout(renderTimeout);

                        renderTimeout = $timeout(function () {
                            var margin = {top: 20, right: 30, bottom: 40, left: 60};

                            var td = [];
                            for (var i in data)
                                if (td.indexOf(data[i].date) === -1)
                                    td.push(data[i].date);

                            if (['none', 'hour', 'day', 'week', 'month'].indexOf(scope.level) !== -1 && td.length > 15)
                                margin.bottom = 70;

                            var width = el.parent()[0].offsetWidth - margin.left - margin.right,
                                height = el.parent()[0].offsetHeight - margin.bottom,
                                dataFields = [],
                                ticks = {
                                    dates: [],
                                    quarters: [],
                                    years: [],
                                    year_weeks: [],
                                    months: [],
                                    weeks: [],
                                    days_month: [],
                                    days_week: [],
                                    hours: []
                                };

                            if (!scope.options)
                                scope.options = {fill: true, values: true};

                            switch (scope.src) {
                                case 'visits_by_time':
                                case 'visits_by_pos':
                                    dataFields = ['value'];
                                    break;
                                case 'turnover_by_time':
                                case 'segments_dynamics':
                                    dataFields = scope.fields;
                                    break;
                            }

                            // set the ranges
                            // var x = d3.scaleLinear().range([0, width]);
                            var x = d3.scaleTime().range([0, width]);
                            var y = d3.scaleLinear().range([height, 0]);


                            var getY = function (d, f) {
                                switch (f) {
                                    case 'customers_lost':
                                        return y(d.customers_lost);
                                        break;
                                    case 'customers_passive':
                                        return y(d.customers_lost + d.customers_passive);
                                        break;
                                    case 'customers_active':
                                        return y(d.customers_lost + d.customers_passive + d.customers_active);
                                        break;
                                    case 'customers_new':
                                        return y(d.customers_lost + d.customers_passive + d.customers_active + d.customers_new);
                                        break;
                                    default:
                                        return y(d[f]);
                                }
                            }

                            // define the area
                            var areas = [];
                            for (var i in dataFields)
                                areas[dataFields[i]] = d3.area()
                                    .x(function (d) {
                                        return x(d.date);
                                    })
                                    .y0(height)
                                    .y1(function (d) {
                                        return getY(d, dataFields[i]);
                                    });


                            var valuelines = [];
                            for (var i in dataFields)
                                valuelines[dataFields[i]] = d3.line()
                                    .x(function (d) {
                                        return x(d.date);
                                    })
                                    .y(function (d) {
                                        return getY(d, dataFields[i]);
                                    });

                            var svg = d3.select(el[0]).append('svg')
                                .attr('width', width + margin.left + margin.right)
                                .attr('height', height + margin.top + margin.bottom)
                                .append('g')
                                .attr('transform',
                                    'translate(' + margin.left + ',' + margin.top + ')');

                            var getMinInterval = function (data) {
                                if (!data)
                                    return 1;

                                if (data[0])
                                    return data[0].date;

                                return 1;
                            }

                            var getMaxInterval = function (data) {
                                if (data[data.length - 1])
                                    return data[data.length - 1].date;

                                return false;
                            }

                            var getTranslate = function (d, f) {
                                switch (f) {
                                    case 'customers_lost':
                                        return 'translate(' + x(d.date) + ',' + y(d.customers_lost) + ')';
                                        break;
                                    case 'customers_passive':
                                        return 'translate(' + x(d.date) + ',' + y(d.customers_lost + d.customers_passive) + ')';
                                        break;
                                    case 'customers_active':
                                        return 'translate(' + x(d.date) + ',' + y(d.customers_lost + d.customers_passive + d.customers_active) + ')';
                                        break;
                                    case 'customers_new':
                                        return 'translate(' + x(d.date) + ',' + y(d.customers_lost + d.customers_passive + d.customers_active + d.customers_new) + ')';
                                        break;
                                    default:
                                        return 'translate(' + x(d.date) + ',' + y(d[f]) + ')';
                                }
                            }

                            var getLabelY = function (d, f) {
                                switch (f) {
                                    case 'customers_lost':
                                        return y(d.customers_lost);
                                        break;
                                    case 'customers_passive':
                                        return y(d.customers_lost + d.customers_passive);
                                        break;
                                    case 'customers_active':
                                        return y(d.customers_lost + d.customers_passive + d.customers_active);
                                        break;
                                    case 'customers_new':
                                        return y(d.customers_lost + d.customers_passive + d.customers_active + d.customers_new);
                                        break;
                                    default:
                                        return y(d[f]);
                                }
                            }

                            var formatDigits = function (num, fixed) {
                                if (num === null)
                                    return null;

                                if (num === 0)
                                    return '0';

                                fixed = (!fixed || fixed < 0) ? 0 : fixed;
                                var b = (num).toPrecision(2).split('e'),
                                    k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 3),
                                    c = k < 1 ? num.toFixed(0 + fixed) : (num / Math.pow(10, k * 3)).toFixed(1 + fixed),
                                    d = c < 0 ? c : Math.abs(c),
                                    e = d + ['', 'K', 'M', 'B', 'T'][k];
                                return e;
                            }

                            data.forEach(function (d) {
                                switch (scope.level) {
                                    case 'none':
                                    case 'month':
                                    case 'day':
                                        d.date = moment(d.date);
                                        break;
                                    case 'week':
                                        if (typeof d.date === 'string' && d.date.indexOf('-') !== -1)
                                            d.date = moment(d.date.split('-')[0]).week(d.date.split('-')[1] * 1 + 1);
                                        break;
                                    case 'quarter':
                                        if (typeof d.date === 'string' && d.date.indexOf('-') !== -1)
                                            d.date = moment(d.date.split('-')[0]).quarter(d.date.split('-')[1] * 1);
                                        break;
                                    case 'hour':
                                        if (typeof d.date === 'string' && d.date.indexOf(' ') !== -1)
                                            d.date = moment(d.date.split(' ')[0]);
                                        break;
                                }
                            });
                            console.log('data::scope.level', scope.level)
                            console.log('data::scope.level', data)

                            var xAxis = d3.axisBottom(x);
                            switch (scope.level) {
                                case 'hour-of-day':
                                    for (var i = 0; i <= 23; i++)
                                        ticks.hours.push(i.toString());

                                    xAxis.tickFormat(d3.format('d'))
                                        .tickValues(ticks.hours);
                                    break;
                                case 'day-of-week':
                                    for (var i = 1; i <= 7; i++)
                                        ticks.days_week.push(i.toString());

                                    xAxis.tickFormat(d3.format('d'))
                                        .tickValues(ticks.days_week);
                                    break;
                                case 'day-of-month':
                                    for (var i = 1; i <= 31; i++)
                                        ticks.days_month.push(i.toString());

                                    xAxis.tickFormat(d3.format('d'))
                                        .tickValues(ticks.days_month);
                                    break;
                                case 'week-of-year':
                                    for (var i = getMinInterval(data); i <= (getMaxInterval(data) || 53); i++)
                                        ticks.weeks.push(i.toString());

                                    xAxis.tickFormat(d3.format('d'))
                                        .tickValues(ticks.weeks);
                                    break;
                                case 'month-of-year':
                                    for (var i = getMinInterval(data); i <= (getMaxInterval(data) || 12); i++)
                                        ticks.months.push(i.toString());

                                    xAxis.tickFormat(d3.format('d'))
                                        .tickValues(ticks.months);
                                    break;
                                case 'year':
                                    for (var i in data)
                                        if (ticks.years.indexOf(data[i].date) === -1)
                                            ticks.years.push(data[i].date);

                                    xAxis.tickFormat(d3.format('d'))
                                        .tickValues(ticks.years);
                                    break;
                                case 'quarter':
                                    for (var i in data)
                                        if (ticks.years.indexOf(data[i].date) === -1)
                                            ticks.quarters.push(data[i].date);

                                    xAxis.tickFormat(function (d) {
                                        return moment(d).format('YYYY-Q');
                                    })
                                        .tickValues(ticks.quarters);
                                    break;
                                case 'none':
                                case 'hour':
                                case 'day':
                                case 'week':
                                case 'month':
                                    for (var i in data)
                                        if (ticks.dates.indexOf(data[i].date) === -1)
                                            ticks.dates.push(data[i].date);

                                    if (ticks.dates.length > 20) {
                                        var fixed_dates = [ticks.dates[0]],
                                            step = parseInt(Math.floor(ticks.dates.length / 20));

                                        for (var i = step; i < ticks.dates.length; i += step)
                                            fixed_dates.push(ticks.dates[i])
                                    }


                                    if (fixed_dates)
                                        ticks.dates = fixed_dates;

                                    if (scope.level === 'week')
                                        xAxis.tickFormat(d3.timeFormat('%Y-%U'))
                                            .tickValues(ticks.dates);
                                    else
                                        xAxis.tickFormat(d3.timeFormat('%Y-%m-%d'))
                                            .tickValues(ticks.dates);
                                    break;
                                default:
                                    xAxis.tickFormat(d3.timeFormat('%Y-%m'))
                                        .tickValues(d3.scaleLinear().domain(x.domain()).ticks(5));
                            }


                            // scale the range of the data
                            x.domain(d3.extent(data, function (d) {
                                return d.date;
                            }));
                            y.domain([0, d3.max(data, function (d) {
                                switch (scope.src) {
                                    case 'visits_by_time':
                                    case 'visits_by_pos':
                                        return d.value;
                                        break;
                                    case 'segments_dynamics':
                                        var max = 0;

                                        for (var i in scope.fields)
                                            max += d[scope.fields[i]];

                                        return max;
                                        break;
                                    case 'turnover_by_time':
                                        var max = 0;

                                        for (var i in scope.fields)
                                            if (d[scope.fields[i]] > max)
                                                max = d[scope.fields[i]];

                                        return max;
                                        break;
                                }
                            })]);

                            for (var i in dataFields) {
                                if (scope.options.fill)
                                    svg.append('path')
                                        .data([data])
                                        .attr('class', 'area area_' + dataFields[i])
                                        .attr('d', areas[dataFields[i]]);
                            }

                            var xAxisPrep = svg.append('g')
                                .attr('transform', 'translate(0,' + height + ')')
                                .call(xAxis);

                            if (['none', 'hour', 'day', 'week', 'month'].indexOf(scope.level) !== -1 && ticks.dates.length > 15)
                                xAxisPrep.selectAll('text')
                                    .attr('x', -50)
                                    .attr('y', 5)
                                    .attr('transform', 'rotate(-45)')
                                    .style('text-anchor', 'start');

                            svg.append('g')
                                .call(d3.axisLeft(y));


                            var colors = [],
                                dots = {};
                            for (var i in dataFields)
                                colors[dataFields[i]] = d3.interpolateRainbow(i / dataFields.length);

                            for (var i in dataFields) {
                                var f = dataFields[i],
                                    line = svg.append('path')
                                        .data([data])
                                        .attr('d', valuelines[f]);

                                if (scope.options.dynamic_colors)
                                    line.attr('stroke', function (d) {
                                        return colors[f];
                                    })
                                        .attr('class', 'line');
                                else
                                    line.attr('class', 'line line_' + f)

                                if (scope.options.values) {
                                    var tooltip = d3.select('body')
                                        .append('div')
                                        .attr('class', 'chart-tooltip hidden');

                                    dots[f] = svg.selectAll('dot_' + f)
                                        .data(data)
                                        .enter()
                                        .append('circle')
                                        .attr('r', 5)
                                        .attr('chartValue', function (d) {
                                            return d[f];
                                        })
                                        .attr('cx', function (d) {
                                            return x(d.date);
                                        })
                                        .attr('cy', function (d) {
                                            return getLabelY(d, f);
                                        })
                                        .on('mouseover', function (d, k) {
                                            var cv = parseFloat(d3.select(d3.event.target).attr('chartValue'));
                                            tooltip.style('left', (d3.event.pageX) + 'px')
                                                .style('top', (d3.event.pageY - 28) + 'px')
                                                .html('<div class="value bold">' +
                                                    formatDigits(cv, 0) +
                                                    '</div>' +
                                                    '<div class="timestamp">' +
                                                    moment(d.date).format('l') +
                                                    '</div>');

                                            tooltip.classed('hidden', false);
                                        })
                                        .on('mouseout', function () {
                                            tooltip.classed('hidden', true);
                                        });

                                    if (scope.options.dynamic_colors) {
                                        dots[f].attr('fill', function (d, k) {
                                            if (d[f] < 1 && scope.src !== 'segments_dynamics')
                                                return 'rgba(255,255,255,0)';
                                            else
                                                return colors[f];
                                        })
                                        dots[f].attr('stroke', function (d, k) {
                                            if (d[f] < 1 && scope.src !== 'segments_dynamics')
                                                return 'rgba(255,255,255,0)';
                                            else
                                                return colors[f];
                                        })
                                        dots[f].attr('stroke-width', '2');
                                    } else {
                                        dots[f].attr('class', function (d, k) {
                                            if (d[f] < 1 && scope.src !== 'segments_dynamics')
                                                return 'hidden';

                                            return 'label-background label-background_' + f + '';
                                        });
                                    }


                                    // var label =
                                    //     svg.selectAll('rect_' + f)
                                    //        .data(data)
                                    //        .enter()
                                    //        .append('rect');

                                    // if (scope.options.dynamic_colors) {
                                    //   label.attr('fill', function(d, k) {
                                    //     if (d[f] < 1 && scope.src !== 'segments_dynamics')
                                    //       return 'rgba(255,255,255,0)';
                                    //     else
                                    //       return colors[f];
                                    //   })
                                    //   label.attr('stroke', function(d, k) {
                                    //     if (d[f] < 1 && scope.src !== 'segments_dynamics')
                                    //       return 'rgba(255,255,255,0)';
                                    //     else
                                    //       return colors[f];
                                    //   })
                                    //   label.attr('stroke-width', '2');
                                    // }
                                    // else
                                    //   label.attr('class', function(d, k) {
                                    //     if (d[f] < 1 && scope.src !== 'segments_dynamics')
                                    //       return 'hidden';
                                    //     else
                                    //       return 'label-background label-background_' + f;
                                    //   });


                                    // var label_text = svg.selectAll('text_' + f)
                                    //                     .data(data)
                                    //                     .enter()
                                    //                     .append('text')
                                    //                       .attr('transform', function(d, k) {
                                    //                         return getTranslate(d, f);
                                    //                       })
                                    //                       .text( function (d) {
                                    //                         return formatDigits(d[f], 0);
                                    //                       })
                                    //                       .attr('font-family', 'monospace')
                                    //                       .attr('font-weight', 'bold')
                                    //                       .attr('font-size', '10px')
                                    //                       .attr('fill', 'white')
                                    //                       .attr('class', function (d, k) {
                                    //                         // if ((d[dataFields[i]] < 2 && scope.src !== 'segments_dynamics') || k ===0)
                                    //                         //   return 'hidden';
                                    //                         if (d[f] < 1 && scope.src !== 'segments_dynamics')
                                    //                           return 'hidden';
                                    //                       })
                                    //                       .attr('dx', function(d) {
                                    //                         d.width = this.getComputedTextLength();
                                    //                         return -(d.width/2);
                                    //                       });

                                    // label.attr('x', function(d){
                                    //         return x(d.date) - d.width / 2 - 5;
                                    //       })
                                    //       .attr('y', function(d){
                                    //         return getLabelY(d, f) - 11;
                                    //       })
                                    //       .attr('width', function (d) {
                                    //         return d.width + 10;
                                    //       })
                                    //       .attr('height', '16');
                                }


                            }
                        }, 300);
                    };
                });
            }
        };
    }]);
